import { usePrevious } from "@restart/hooks";
import { useEffect, useLayoutEffect, useRef } from "react";
import { getFocusableChildren } from "../../utils/keyboard";
const useFocus = (id, numRows) => {
    const focusIdRef = useRef(undefined);
    const previousNumRows = usePrevious(numRows);
    useLayoutEffect(() => {
        var _a, _b;
        if (previousNumRows && previousNumRows !== numRows && focusIdRef.current) {
            // if not first time table loaded and previous number of rows changed focus on first newly loaded row
            const cellOfLastRow = (_a = document === null || document === void 0 ? void 0 : document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.querySelector(`[role=row]:nth-child(${previousNumRows + 1}) [role=gridcell]:first-child`);
            if (cellOfLastRow) {
                const focusableChildren = getFocusableChildren(cellOfLastRow);
                (_b = focusableChildren === null || focusableChildren === void 0 ? void 0 : focusableChildren[0]) === null || _b === void 0 ? void 0 : _b.focus({ preventScroll: true });
            }
        }
    }, [numRows]);
    useEffect(() => {
        const element = document.getElementById(id);
        if (!element) {
            return;
        }
        const onFocusIn = (e) => {
            var _a;
            focusIdRef.current = e.target.id || ((_a = e.target.closest("[id]")) === null || _a === void 0 ? void 0 : _a.id);
        };
        element.addEventListener("focusin", onFocusIn);
        return () => {
            element.removeEventListener("focusin", onFocusIn);
        };
    }, [id]);
    const onBlur = (e) => {
        if (e.relatedTarget) {
            focusIdRef.current = undefined;
        }
    };
    return {
        onBlur,
    };
};
export default useFocus;
//# sourceMappingURL=useFocus.js.map